import React from 'react'
import { Icon, SpinnerLoader, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const EmptyItem = ({
  loading,
  emptyPlaceholder,
  isShowIcon,
}: {
  loading: boolean
  emptyPlaceholder?: string
  isShowIcon?: boolean
}) => {
  return (
    <div className={styles.wrap}>
      {isShowIcon && <Icon icon='inboxes2' />}
      {loading ? (
        <SpinnerLoader
          ariaLabel={'SendFromEmptyItem'}
          size={10}
          indeterminatecolor={'var(--content-primary-tertiary)'}
        />
      ) : (
        <Typography
          color={'var(--content-primary-disabled)'}
          variant={'body-md-regular'}
          ariaLabel={'placeholder'}
        >
          {emptyPlaceholder}
        </Typography>
      )}
    </div>
  )
}
